import styled from "styled-components";

const FormField = styled.div`
    display: inline-block;
    width: 100%;
    position: relative;
    `;

export default FormField;
